// extracted by mini-css-extract-plugin
export var circle = "_fa-1";
export var exitConfirmationModal = "_fa-5";
export var iframe = "_fa-0";
export var offline = "_fa-3";
export var online = "_fa-2";
export var workstationSelectError = "_fa-4";